import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryDropdownSection from './components/CategoryDropdownSection';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import WhyNeedSection from './components/WhyNeedSection';
import TemplateSection from './components/TemplateSection';
import ReviewSection from './components/ReviewSection';
import ShippingSection from './components/ShippingSection';
import CouponSection from './components/CouponSection';
import SecuritySection from './components/SecuritySection';
import FaqSection from './components/FaqSection';
import PillarArticles from './components/PillarArticles';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <CategoryDropdownSection />
          <CategoryGrid />
          <WhatIsSection />
          <WhyNeedSection />
          <TemplateSection />
          <PillarArticles />
          <ReviewSection />
          <ShippingSection />
          <CouponSection />
          <SecuritySection />
          <FaqSection />
        </article>
      </main>
      <Footer />
    </div>
  );
}